export const IMAGE_OPTIMIZER_VARIANT_PLACEHOLDER = "__VARIANT__";
export const PRODUCT_IMAGE_CDN_HOST = "cdn.storerouter.ai";
// Published URLs and stored projections can outlive frontend deployments.
export const PRODUCT_IMAGE_CDN_HOSTS: readonly string[] = [
  PRODUCT_IMAGE_CDN_HOST,
  "cdn.octogen.ai",
];
export const IMAGE_OPTIMIZER_HOST = "img.storerouter.ai";
export const IMAGE_OPTIMIZER_HOSTS: readonly string[] = [IMAGE_OPTIMIZER_HOST, "img.octogen.ai"];
export const DEFAULT_IMAGE_OPTIMIZER_FORMAT = "avif";

// Widths the self-hosted image optimizer is willing to serve. Must stay in
// sync with apps/octogen-image-optimizer/src/octogen/image_optimizer/config.py
// (DEFAULT_WIDTHS) or with whatever OCTOGEN_IMAGE_OPTIMIZER__ALLOWED_WIDTHS
// the Cloud Run service is deployed with. Requests for any other width return
// HTTP 400 from the service.
//
// Split into deviceSizes (responsive page assets) and imageSizes (small
// thumbnails / icons) so Next.js `images.deviceSizes` / `images.imageSizes`
// can be wired directly from here, keeping the frontend and backend in lock
// step.
export const ALLOWED_DEVICE_SIZES = [512, 768, 1024, 1536, 2048] as const;
export const ALLOWED_IMAGE_SIZES = [64, 128, 256, 384] as const;
export const ALLOWED_WIDTHS = [...ALLOWED_IMAGE_SIZES, ...ALLOWED_DEVICE_SIZES] as const;
